import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

const SkeletonLoader = ({ count = 3 }) => (
  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
    {Array.from({ length: count }, (_, index) => (
      <Box
        key={index}
        sx={(theme) => ({
          flex: '1 1 200px',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: `${theme.shape.borderRadius}px`,
          bgcolor: theme.palette.background.paper,
        })}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Skeleton
            variant="rectangular"
            width={40}
            height={40}
            sx={(theme) => ({ borderRadius: `${theme.shape.borderRadius}px` })}
          />
          <Skeleton variant="text" width="60%" sx={{ fontSize: '0.875rem' }} />
        </Stack>
        <Skeleton variant="text" width="45%" sx={{ fontSize: '2rem' }} />
        <Skeleton variant="text" width="70%" sx={{ fontSize: '0.75rem' }} />
      </Box>
    ))}
  </Box>
);

export default SkeletonLoader;